<template>
    <div v-if="show" class="splash-screen" :style="style">
        <div class="splash-screen-content">
            <a :href="options.link">
                <img class="splash-screen-image" :src="options.image" />
            </a>
        </div>
        <button class="splash-screen-close" aria-label="Close" @click="show = false"></button>
    </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
        return {
            show: false,
            options: {
                link: null,
                image: null,
                background_color: null,
                background_image: null
            }
        };
    },

    mounted() {
        this.load();
    },

    computed: {
        style() {
            return {
                backgroundImage: this.options.background_image,
                backgroundColor: this.options.background_color
            };
        }
    },

    methods: {
        handleOptions(options) {
            const defaultDeviceWidth = 1110;
            options.deviceWidth = options.deviceWidth || defaultDeviceWidth;
            options.image = options.image_desktop;

            if (this.willBeMobile(options)) {
                options.image = options.image_mobile;
            }

            if (!options.image || !options.background_color) {
                return false;
            }

            this.show = true;
            return (this.options = {
                ...this.options,
                ...options
            });
        },

        willBeMobile(options) {
            return (
                window.innerWidth <= options.deviceWidth && options.image_mobile
            );
        },

        getUrlParameter(name) {
            const url = decodeURIComponent(window.location.search.substring(1));
            const queries = url.split("&");

            for (const index in queries) {
                const [key, value] = queries[index].split("=");

                if (key === name) {
                    return value === undefined ? true : value;
                }
            }
        },

        willHideSplash() {
            try {
                return (
                    localStorage && localStorage.getItem("splash") === "hide"
                );
            } catch (err) {}

            return true;
        },

        load() {
            if (this.willHideSplash()) {
                console.log("Splash is hidden based on localStorage config.");
                return false;
            }

            const promo = this.getUrlParameter("promo") || "";
            const token = this.getUrlParameter("token") || "";
            const page = window.location.pathname;
            const url = "/api/splash";

            const request = axios.get(url, {
                params: {
                    promo,
                    token,
                    page
                }
            });

            request
                .then(response => {
                    this.handleOptions(response.data);
                })
                .catch(error => {
                    console.error(error);
                });
        }
    }
};
</script>
